module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "save-fixed-btn"
  }, [(_vm.myTimesheetPage) ? _c('div', [((_vm.timesheetStatus.status === _vm.statusList.notSubmit && _vm.isMyTimesheet) || _vm.timesheetStatus.status === _vm.statusList.reject || (_vm.timesheetStatus.status === _vm.statusList.pending && _vm.isAdmin)) ? _c('button', {
    staticClass: "button is-success",
    on: {
      "click": _vm.toCheckin
    }
  }, [_c('span', [_vm._v("Check in")])]) : _vm._e(), _vm._v(" "), ((_vm.timesheetStatus.status === _vm.statusList.notSubmit && _vm.isMyTimesheet) || _vm.timesheetStatus.status === _vm.statusList.reject || (_vm.timesheetStatus.status === _vm.statusList.pending && _vm.isAdmin)) ? _c('button', {
    staticClass: "button is-warning",
    on: {
      "click": _vm.toCheckout
    }
  }, [_c('span', [_vm._v("Check out")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.toPreview
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _c('span', [_vm._v(" Preview")])]), _vm._v(" "), ((_vm.timesheetStatus.status === _vm.statusList.notSubmit && _vm.isMyTimesheet) || _vm.timesheetStatus.status === _vm.statusList.reject || (_vm.timesheetStatus.status === _vm.statusList.pending && _vm.isAdmin)) ? _c('button', {
    staticClass: "button is-danger",
    on: {
      "click": _vm.saveTimesheet
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v(" Save")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.previewTimesheetPage) ? _c('div', [(_vm.isMyTimesheet && (_vm.timesheetStatus.status === _vm.statusList.notSubmit || _vm.timesheetStatus.status === _vm.statusList.reject)) ? _c('div', [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitTimesheet
    }
  }, [_vm._v("Submit")])]) : _vm._e(), _vm._v(" "), (_vm.isAdmin && _vm.timesheetStatus.status === _vm.statusList.pending) ? _c('div', [_c('button', {
    staticClass: "button is-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.approveTimesheet
    }
  }, [_vm._v("Approve")]), _vm._v(" "), _c('button', {
    staticClass: "button is-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.rejectTimesheet
    }
  }, [_vm._v("Reject")])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72421d3b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/layout/FooterBar.vue
// module id = 371
// module chunks = 66